import { api } from './api';

export interface LoginCredentials {
    email: string;
    password: string;
}

export interface User {
    id: number;
    name: string;
    email: string;
    role: string;
}

export interface AuthResponse {
    user: User;
    token: string;
    message: string;
}

export const authService = {
    /**
     * Login user and get token
     */
    async login(credentials: LoginCredentials): Promise<AuthResponse> {
        const response = await api.post<AuthResponse>('/v1/auth/login', credentials);
        
        // Store token in localStorage
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        
        return response.data;
    },

    /**
     * Logout user
     */
    async logout(): Promise<void> {
        try {
            await api.post('/v1/auth/logout');
        } catch (error) {
            console.warn('Logout API call failed, but continuing with local cleanup');
        } finally {
            // Clear local storage
            localStorage.removeItem('token');
            localStorage.removeItem('user');
        }
    },

    /**
     * Get current user
     */
    async getCurrentUser(): Promise<User | null> {
        try {
            const response = await api.get<{ user: User }>('/v1/auth/user');
            return response.data.user;
        } catch (error: any) {
            if (error.response?.status === 401) {
                console.log('🔐 getCurrentUser: User not authenticated (401)');
            } else {
                console.warn('🔐 getCurrentUser: Unexpected error:', error.message);
            }
            return null;
        }
    },

    /**
     * Check if user is authenticated
     */
    isAuthenticated(): boolean {
        return !!localStorage.getItem('token');
    },

    /**
     * Get stored user
     */
    getStoredUser(): User | null {
        const userStr = localStorage.getItem('user');
        return userStr ? JSON.parse(userStr) : null;
    },

    /**
     * Get stored token
     */
    getToken(): string | null {
        return localStorage.getItem('token');
    }
}; 